import { render, staticRenderFns } from "./Deleter.vue?vue&type=template&id=7b191ad4"
import script from "./Deleter.vue?vue&type=script&lang=js"
export * from "./Deleter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports